import { resolveVariables, Variable } from "@bpmn-io/dmn-variable-resolver/lib/core";

class CustomVariableProvider {
    constructor(variableResolver: any) {
        variableResolver.registerProvider(this);
    }

    getVariables(variables: any, element: any) {
        const resolvedVariables = resolveVariables(element);

        if (element.$type === "dmn:InputClause") {
            // We don't want to filter out the variables for input clauses
            return variables.concat(resolvedVariables);
        }

        // Filter out our custom variables for the rules
        const prefixesToRemove = ["env.", "process.", "result[", "trigger.", "var."];
        const filteredVariables = resolvedVariables.filter((v: Variable) => !prefixesToRemove.some((prefix) => v.name.startsWith(prefix)));
        return variables.concat(filteredVariables);
    }
}

CustomVariableProvider.$inject = ["variableResolver"];

export default {
    __init__: ["dmnVariableProvider"],
    dmnVariableProvider: ["type", CustomVariableProvider]
};
